import styled from '@emotion/styled'

import { breakpoints, colors, spacing } from 'main/ui'

const Section = styled.div`
  display: flex;
  flex-direction: row;
  padding: ${spacing.majorScale(2)}px 0;

  :not(:first-child) {
    border-top: 1px solid ${colors.border.default};
  }

  > * {
    flex: 1;
  }

  @media (max-width: ${breakpoints.lg}px) {
    flex-direction: column;
    margin: 0 ${spacing.majorScale(2)}px;

    > :not(:first-child) {
      border-top: 1px solid ${colors.border.default};
      margin-top: ${spacing.majorScale(2)}px;
      padding-top: ${spacing.majorScale(2)}px;
    }
  }
`

export default Section
